"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderType = void 0;
var OrderType;
(function (OrderType) {
    OrderType["ASC"] = "asc";
    OrderType["DESC"] = "desc";
})(OrderType || (exports.OrderType = OrderType = {}));
//# sourceMappingURL=entities.js.map